export default __webpack_public_path__ + "static/media/empty2.2d2c6ee3.png";